import type { ContextGuards, Guard } from './types.js';

export function not(guard: Guard) {
  return (ctx: ContextGuards) => !guard(ctx);
}
